import {
    iconClient,
    iconCalculator,
    iconReportsDefault,
    iconSearch,
    iconPreAprobador,
    iconReports,
    iconDigitalSignature,
    iconZonification,
    iconPayment,
    iconAddDocsPayment,
    iconindividual,
    icondual,
    iconWarranty,
    iconFinancies,
    iconAddDocs,
    iconConsults,
    iconCreditsMonotoring
} from '../defaultValues';

const data = {
    role_ff3ee6ad1e3b4996b3f4409acd9c7c92: [
        {
            id: 'credits',
            icon: iconCreditsMonotoring,
            label: 'Solicitudes de crédito',
            subs: [
                {
                    id: 'gogo',
                    icon: iconCreditsMonotoring,
                    label: 'Consultar',
                    to: '/app/credits',
                },
                {
                    id: 'searcRequest',
                    icon: iconSearch,
                    label: 'Buscar',
                    to: '/app/reports/searchRequest',
                },
               
                {
                    id: 'comercialMonotoring',
                    icon: iconConsults,
                    label: 'Seguimiento Comercial',
                    to: '/app/ExecutiveMonitoring',
                },

            ],
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'wompi',
            icon: iconFinancies,
            label: 'Wompi',
            to: '/app/WompiExecutive',
        },
        {
            id: 'cobranza',
            icon: iconPayment,
            label: 'Cobranza',
            to: '/app/calculator',
            subs: [
                {
                    id: 'payment',
                    icon: iconReportsDefault,
                    label: 'Generar',
                    to: '/app/paymentDocument',
                    subs: [
                        {
                            id: 'payment',
                            icon: iconindividual,
                            label: 'Individual',
                            to: '/app/paymentDocument',
                        },
                        {
                            id: 'payment',
                            icon: icondual,
                            label: 'Masivo',
                            to: '/app/massivePaymentExecutive',
                        },
                    ],
                },
                {
                    id: 'signautre',
                    icon: iconAddDocsPayment,
                    label: 'Adjuntar',
                    to: '/app/ExecutiveSignature',
                },
            ],
        },
        {
            id: 'neww',
            icon: iconWarranty,
            label: 'Garantía Vehicular',
            to: '/app/warranty',
        },
        {
            id: 'runtPreRegistration',
            icon: iconAddDocs,
            label: 'Pre registro RUNT',
            to: '/app/credits/RuntPreRegistration',
        },
         
        {
            id: 'pre-aprobador',
            icon: iconPreAprobador,
            label: 'Pre-aprobador',
            to: '/app/pre-aprobador',
        },
        {
            icon: iconDigitalSignature,
            label: 'Firma Electrónica',
            to: '/app/electronicSignature/ElectronicSignature',
        },
        {
            id: 'zonification',
            icon: iconZonification,
            label: 'Zonificación',
            to: '/app/zonificacionEjecutivo',
        },
        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/blank-page',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Desempeño Usuario',
                    to: '/app/reports/teamPerformanceExecutive',
                },
                {
                    id: 'mora-collection',
                    icon: iconReportsDefault,
                    label: 'Mora',
                    to: '/app/collection/lista',
                },
                {
                    id: 'par1&par30-collection',
                    icon: iconReportsDefault,
                    label: 'Par1 & Par30',
                    to: '/app/collection/per1AndPer30Executive',
                },
            ],
        },
       
       
    ],
};
export default data;
